<script setup lang="ts">
import PhosphorIcon from "@/components/UI/PhosphorIcon.vue";

/** Étape 1 : pourquoi l'interface change, en trois objectifs. */
const GOALS = [
  { key: "screens", icon: "devices" },
  { key: "tools", icon: "star" },
  { key: "custom", icon: "sliders-horizontal" },
] as const;
</script>

<template>
  <div>
    <p class="ui-intro">{{ $t("canvas:uiChanges.intro") }}</p>
    <div class="goals">
      <div v-for="goal in GOALS" :key="goal.key" class="goal">
        <span class="goal-icon">
          <PhosphorIcon :name="goal.icon" :size="22" weight="duotone" />
        </span>
        <div class="goal-title">
          {{ $t(`canvas:uiChanges.goals.${goal.key}.title`) }}
        </div>
        <div class="goal-text">
          {{ $t(`canvas:uiChanges.goals.${goal.key}.text`) }}
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.ui-intro {
  margin: 0 0 16px;
  font-size: 14px;
  line-height: 1.5;
  color: rgba(255, 255, 255, 0.85);
}

.goals {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(min(190px, 100%), 1fr));
  gap: 12px;
}

.goal {
  padding: 14px;
  border: 1px solid var(--canvas-border);
  border-radius: 12px;
  background-color: rgba(255, 255, 255, 0.04);
}

.goal-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  margin-bottom: 10px;
  border-radius: 12px;
  background-color: var(--canvas-btn-mode-bg);
  color: var(--canvas-btn-active-bg);
}

.goal-title {
  font-size: 15px;
  font-weight: 600;
  color: #fff;
}

.goal-text {
  margin-top: 4px;
  font-size: 13px;
  line-height: 1.45;
  color: rgba(255, 255, 255, 0.7);
}
</style>
